import { Container, Row } from "reactstrap";
import { FormControlsTitle, FormValidationTitle } from "../../../../../constants";
import BrowserDefaults from "./BrowserDefaults";
import TooltipFormValidation from "./tooltipFormValidation";
import ValidationForm from "./validationForm";
import Breadcrumbs from "../../../../../coreComponents/breadcrumbs";

const FormValidationContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={FormValidationTitle} parent={FormControlsTitle} />
      <Container fluid>
        <Row>
          <TooltipFormValidation />
          <BrowserDefaults />
          <ValidationForm />
        </Row>
      </Container>
    </>
  );
};

export default FormValidationContainer;
